/**
 * Проверяет является ли переданное значение функцией.
 *
 * @param value Значение, которое нужно проверить.
 * @returns true, если переданное значение является функцией, иначе false.
 * @example
 * ```typescript
 * import { isFunction } from '@direct-frontend/stdlib';
 *
 * isFunction(() => {})); // true
 * isFunction(1); // false
 * ```
 */
export function isFunction(value) {
    return typeof value === 'function';
}
